import { motion } from 'framer-motion'

const logos = [
  'b1bc6a20-555f-444d-b192-3f0158c58d00',
  'c1d0aa30-a456-454e-41d5-511983e65100',
  '58262d5f-7657-419c-fe94-8bf73ca34400',
  '4d43438c-80ac-4b64-4df9-7ea436ccfc00',
  '3218152b-662f-415c-aea4-6b207f7f2600'
].map(id => `https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/${id}/public`)

const doubledLogos = [...logos, ...logos]

export default function LogoCarousel() {
  return (
    <div className="relative w-[100vw] md:w-full left-[50%] right-[50%] -ml-[50vw] md:ml-0 md:left-0 mr-[50vw] md:mr-0 md:right-0 overflow-hidden py-8 opacity-40">
      <motion.div
        className="flex"
        animate={{
          x: ["0%", "-50%"]
        }}
        transition={{
          x: {
            duration: 20,
            repeat: Infinity,
            ease: "linear"
          }
        }}
        style={{
          width: `${doubledLogos.length * 200}px`
        }}
      >
        {doubledLogos.map((logo, index) => (
          <motion.div
            key={index}
            className="w-[300px] md:w-[350px] flex items-center justify-center px-0 md:px-8 mt-10"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 1,
              ease: "easeInOut"
            }}
          >
            <img
              src={logo}
              alt="Inteligência artificial para advogados"
              className="h-24 w-auto object-contain"
              loading="lazy"
              style={{
                filter: "blur(0px)",
                transition: "opacity 1s ease-in-out, transform 1s ease-in-out"
              }}
            />
          </motion.div>
        ))}
      </motion.div>
      {/* Fade effect on the edges */}
      <div className="absolute top-0 left-0 w-40 h-full bg-gradient-to-r from-[#081428] to-transparent pointer-events-none hidden md:block" />
      <div className="absolute top-0 right-0 w-40 h-full bg-gradient-to-l from-[#081428] to-transparent pointer-events-none hidden md:block" />
    </div>
  )
}
